<template>
  <div>
    <v-data-table v-model="selected" :show-select="totaleArticoli > 0" item-key="_id" :headers="headers"
      :items="articoliSorted" :options.sync="options" :server-items-length="totaleArticoli" :loading="loading"
      class="elevation-1" @click:row="clickRow" @dblclick:row="dblclickRow" :disable-sort="true" :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }" :single-expand="singleExpand" :expanded.sync="expanded" show-expand dense>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Articoli abilitati per eCommerce</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="success" class="mb-2 mr-5" @click="onAggiornaGiacenze"
            :loading="aggiornaGiacenzaInCorso">Aggiorna giacenze</v-btn>
          <v-btn color="primary" class="mb-2" @click="onSincronizzaVariazioni" :loading="sincronizzazioneInCorso"
            title="La procedura può impiegare alcuni minuti...">Sincronizza variazioni</v-btn>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Confermi cancellazione articolo?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
                <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <dialog-errore :show="dialogErrore" title="Abilitazione eCommerce" />
          <v-dialog v-model="dialogECommerce" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Gestione eCommerce</v-card-title>
              <v-card-text>Confermi inversione abilitazione eCommerce per i prodotti selezionati ?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="eCommerceConfirm">SI</v-btn>
                <v-btn color="blue darken-1" text @click="dialogECommerce = false">NO</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <carica-prodotti class="mb-3" @refresh="refresh" />
        <crea-prodotti-ecommerce v-if="mostraCreazioneProdottosuECommerce" class="mb-3" @refresh="refresh"/>
        <filtri :usaTagliaColore="usaTagliaColore" @ricerca="onRicerca" />
      </template>
      <template v-slot:[`item.speciali`]="{ item }">
        <v-icon v-if="item.lotti && item.lotti.gestione && item.lotti.gestione.abilita" small :title="titleLotti(item)"
          :color="coloreLotti(item)">mdi-clipboard-text-outline</v-icon>
        <v-icon v-if="item.lotti && !item.lotti.gestione && item.lotti.prodottoBase" small :title="titleLotti(item)"
          :color="coloreLotti(item)">mdi-clipboard-text-outline</v-icon>
        <v-icon v-if="item.bom && item.bom.gestione && item.bom.gestione.abilita" small :title="titleBom(item)"
          :color="coloreBom(item)">mdi-family-tree</v-icon>
        <v-icon v-if="item.eCommerce && item.eCommerce.abilita" small title="Abilitato per eCommerce" class="ml-2"
          :color="coloreCommerce(item)" @click="apriCommerce(item)">{{ allegatiEcommerce(item) ? 'mdi-cart' : 'mdi-cart-outline' }}</v-icon>
      </template>
      <template v-slot:[`item.prezzo.L1.base`]="{ item }">
        {{ item.prezzo && item.prezzo.L1 && item.prezzo.L1.base | dueDecimali }}
      </template>
      <template v-slot:[`item.prezzo.L2.base`]="{ item }">
        {{ item.prezzo && item.prezzo.L2 && item.prezzo.L2.base | dueDecimali }}
      </template>
      <template v-slot:[`item.magazzino.prezzoAcquisto`]="{ item }">
        {{ item.magazzino && item.magazzino.prezzoAcquisto | dueDecimali }}
      </template>
      <template v-slot:[`item.magazzino.giacenza`]="{ item }">
        <span :title="giacenzaTotale(item)">{{ calcolaGiacenza(item) | dueDecimali }}</span>
      </template>
      <template v-slot:[`item.magazzino.giacenzaWeb`]="{ item }">
        <span>{{ calcolaGiacenza(item, magazzinoWeb) | dueDecimali }}</span>
      </template>
      <template v-slot:[`item.eCommerce.giacenza`]="{ item }">
        <span :class="calcolaGiacenza(item, magazzinoWeb) !== parseFloat(item.eCommerce.giacenza) ? 'red--text' : ''">{{
          item.eCommerce.giacenza | dueDecimali }}</span>
      </template>
      <template v-slot:[`item.prezzo.web`]="{ item }">
        {{ item.prezzo[listinoWeb] && item.prezzo[listinoWeb].base | dueDecimali }}
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="articoliSelected">
          <v-tabs dense v-model="tab[item._id]">
            <v-tab key="dettaglioEC" class="articoliSelected">Dettaglio eCommerce</v-tab>
            <v-tab key="allegati">Immagini</v-tab>
            <v-tab key="descrizioni">Descrizioni</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab[item._id]">
            <v-tab-item key="dettaglioEC">
              <dettaglio-e-commerce :item="item" :refresh="trigRefreshEcommerce" @aggiorna="aggiornaConfigurazioni" />
            </v-tab-item>
            <v-tab-item key="allegati">
              <allegati :idProdotto="item._id" :allegati="item.allegati" :triggerUpdate="triggerUpdate"
                @change="onChangeFile" @refresh="refreshAllegati(item)" />
            </v-tab-item>
            <v-tab-item key="descrizioni">
              <v-card>
                <v-card-title>Descrizioni prodotto</v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12">
                      <v-textarea label="Descrizione breve" :value="item.eCommerce.descrizioneBreve"
                        rows="1"></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea label="Descrizione" :value="item.eCommerce.descrizione"></v-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" class="mr-5" @click="salvaDescrizioni(item)">Salva</v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <!--           <v-tab-item key="configurazioniEC">
            <configurazioni-e-commerce :item="item" :refresh="trigRefreshEcommerce" @aggiorna="aggiornaConfigurazioni"/>
          </v-tab-item> -->
          </v-tabs-items>
        </td>
      </template>
    </v-data-table>
    <speed-dial :moduloECommerce="moduloECommerce" @comando="onSpeedDialogComando" />
    <stampa-etichette ref="stampaEtichette" />
  </div>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import { dynamicSortMultiple, calcolaHash, delay } from '@/components/helpers.js'
  import DialogErrore from '@/components/dialogErrore'
  import SpeedDial from './speedDial.vue'
  import StampaEtichette from '@/components/etichette/stampaEtichette'
  import Filtri from './filtri'
  import CaricaProdotti from './elementi/caricaProdotti'
  import CreaProdottiEcommerce from './elementi/creaProdottiEcommerce'
  import DettaglioECommerce from './elementi/dettaglioEC'
  /* import ConfigurazioniECommerce from './elementi/configurazioniEC' */
  import prodotti from '@/services/prodottiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import Allegati from './elementi/allegati'
  import eCommerce from '@/services/eCommerceService'

  export default {
    components: {
      DialogErrore,
      Filtri,
      CaricaProdotti,
      CreaProdottiEcommerce,
      SpeedDial,
      StampaEtichette,
      DettaglioECommerce,
      /* ConfigurazioniECommerce, */
      Allegati
    },
    mixins: [verificaLicenza],
    data() {
      return {
        totaleArticoli: 0,
        articoli: [],
        selected: [],
        loading: true,
        options: { itemsPerPage: 50 },
        headersDefault: [ // Caricato se non ci sono impostazioni diverse nel DB
          { text: 'Codice', value: 'codice', align: 'start' },
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Taglia', value: 'varianti.variante1.descrizione' },
          { text: 'Colore', value: 'varianti.variante2.descrizione' },
          { text: 'Marchio', value: 'marchio' },
          /* { text: 'Listino €', value: 'prezzo.L2.base', align: 'end' }, */
          { text: 'Prezzo €', name: 'prezzo', value: 'prezzo.L1.base', align: 'end' },
          { text: 'Prezzo Web €', name: 'prezzo', value: 'prezzo.web', align: 'end' },
          /* { text: 'Acquisto €', value: 'magazzino.prezzoAcquisto', align: 'end' }, */
          { text: 'Giacenza', value: 'magazzino.giacenza', align: 'end' },
          { text: 'Giacenza web', value: 'magazzino.giacenzaWeb', align: 'end' },
          { text: 'Giacenza online', value: 'eCommerce.giacenza', align: 'end' }
        ],
        headersBase: [
          /*  { text: 'Actions', value: 'actions', sortable: false }, */
          { text: '', value: 'data-table-expand' }
        ],
        headersSpeciali: [
          { text: '', value: 'speciali', width: 80 }
        ],
        headersBO: [],
        dialogErrore: false,
        dialogDelete: false,
        dialogECommerce: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: {
          tipoItem: 'PRODOTTO',
          testo: '',
          marchio: [],
          variante1: [],
          variante2: [],
          stagione: [],
          categoria1: [],
          categoria2: []
        },
        expanded: [],
        singleExpand: false,
        tab: {},
        trigRefreshVendite: 0,
        trigRefreshMovimenti: 0,
        trigRefreshLotti: 0,
        trigRefreshDistintaBase: 0,
        trigRefreshVariazioni: 0,
        trigRefreshMagazzini: 0,
        trigRefreshEcommerce: 0,
        triggerUpdate: 0,
        usaTagliaColore: false,
        usaLotti: false,
        usaDistintaBase: false,
        usaVariazioni: false,
        codiceCancellazione: '',
        moduloECommerce: false,
        moduloLotti: false,
        magazzinoWeb: '',
        listinoWeb: '',
        gestioneSeparataStockVarianti: false,
        sincronizzazioneInCorso: false,
        aggiornaGiacenzaInCorso: false,
        mostraCreazioneProdottosuECommerce: false
      }
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'Nuovo Articolo' : 'Modifica Articolo'
      },
      productSaved() {
        return this.$store.getters['prodotti/saved']
      },
      refreshList() {
        return this.$store.getters['prodotti/refresh']
      },
      articoliSorted() {
        const els = this.articoli
        const elSorted = els.length > 0 ? els.sort(dynamicSortMultiple('descrizione', 'varianti.variante2.descrizione', 'varianti.variante1.descrizione')) : []
        return elSorted
      },
      headers() {
        /*         let ecommerce = this.moduloECommerce ? this.headersECommerce : []
                let lotti = this.moduloLotti ? this.headersLotti : [] */
        let base = this.moduloECommerce || this.moduloLotti ? this.headersSpeciali : []
        return base.concat(this.headersBO).concat(this.headersBase)
      },
      magazziniMultipli() {
        return this.$store.getters['magazzini/magazziniMultipli']
      },
      magazzinoSelezionato() {
        // Si può usare il getter perchè la chiamata asincrona è stata fatta dalla root
        return this.$store.getters['magazzini/codiceMagazzino']
      }
    },
    watch: {
      options: {
        async handler() {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete(val) {
        val || this.closeDelete()
      },
      async productSaved(value) {
        if (value) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('prodotti/CLEAR_REFRESH')
        }
      }
    },
    async created() {
      this.defaultItem = await prodotti.getModello()
      const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.headersBO = _.get(backoffice, 'prodottiWeb.griglia.headers', this.headersDefault)
      this.usaTagliaColore = backoffice.usaTagliaColore || false
      this.usaLotti = backoffice.usaLotti || false
      this.usaDistintaBase = backoffice.usaDistintaBase || false
      this.usaVariazioni = backoffice.usaVariazioni || false
      this.codiceCancellazione = backoffice.codiceCancellazione || '0000'

      this.moduloECommerce = _.get(backoffice, 'eCommerce.abilitato', false) || false // TODO: Impostare se licenza abilitata
      this.moduloLotti = _.get(backoffice, 'usaLotti', false) || false // TODO: Impostare se licenza abilitata
      this.magazzinoWeb = _.get(backoffice, 'eCommerce.magazzino', '')
      this.listinoWeb = _.get(backoffice, 'eCommerce.listino', 'L1')
      this.gestioneSeparataStockVarianti = _.get(backoffice, 'eCommerce.gestioneSeparataStockVarianti', false)
      this.mostraCreazioneProdottosuECommerce = _.get(backoffice, 'eCommerce.mostraCreazioneProdottosuECommerce', false)
    },
    async mounted() {
      await this.gestioneToken()
      prodotti.popolaPreCache()
    },
    methods: {
      async onAggiornaGiacenze() {
        this.aggiornaGiacenzaInCorso = true
        await eCommerce.aggiornaGiacenze()
        this.aggiornaGiacenzaInCorso = false
      },
      async onSincronizzaVariazioni() {
        this.sincronizzazioneInCorso = true
        await eCommerce.sincronizzaVariazioni(true)
        // await prodotti.ecommerceSincronizzaVariazioni()
        this.sincronizzazioneInCorso = false
      },
      coloreCommerce(item) {
        return item.eCommerce && item.eCommerce.prodottoConVarianti && item.eCommerce.tipo === 'variable' ? 'red' : ''
      },
      async refresh() {
        await this.getDataFromApi()
      },
      async aggiornaConfigurazioni(item) {
        const id = item._id
        let prodotto = await prodotti.getProdotto(id)
        if (prodotto) {
          prodotto.eCommerce = item.eCommerce
          prodotto.prezzo = item.prezzo
          prodotto.magazzino = item.magazzino
          await prodotti.aggiornaProdotto(prodotto)
          this.trigRefreshEcommerce++
        }
      },
      /* async onAggiornaPreparazioni(item) {
        const id = item._id
        let prodotto = await prodotti.getProdotto(id)
        if (prodotto) {
          prodotto.preparazioni = item.preparazioni
          await prodotti.aggiornaProdotto(prodotto)
          this.trigRefreshVariazioni++
        }
      }, */
      apriCommerce(item) {
        if (item.eCommerce && item.eCommerce.url) {
          window.open(item.eCommerce.url)
        }
      },
      calcolaGiacenza(item, magazzino) {
        const giacenza = _.get(item, 'magazzino.giacenza', 0)
        if (!this.magazziniMultipli) {
          return giacenza
        } else {
          const giacenzaParziale = _.get(item, 'magazzino.giacenzaParziale', 0)
          if (typeof giacenzaParziale === 'object' && !_.isEmpty(giacenzaParziale)) {
            const gg = giacenzaParziale[magazzino || this.magazzinoSelezionato] || {}
            return gg.giacenza || 0
          } else {
            return this.magazzinoSelezionato === 'mag01' ? giacenza : 0
          }
        }
      },
      giacenzaTotale(item) {
        return `Giacenza totale: ${item.magazzino.giacenza || 0}`
      },
      titleLotti(item) {
        if (item.lotti && item.lotti.gestione) {
          return 'Abilitato per gestione lotti' + (item.lotti && item.lotti.prodottoBase ? ' - Prodotto Base' : '')
        } else {
          return (item.lotti && item.lotti.prodottoBase ? 'Prodotto Base' : '')
        }
      },
      coloreLotti(item) {
        return item.lotti && item.lotti.prodottoBase ? 'red' : ''
      },
      titleBom(item) {
        return 'Abilitato per gestione distinta base'
      },
      allegatiEcommerce(item) {
        return item.allegati && item.allegati.filter(x => ['eCommerce', 'tutto'].includes(_.get(x, 'description.codice'))).length > 0 ? 'blue' : ''
      },
      coloreBom(item) {
        // TODO: Gestire se necessario
        return ''
      },
      async onRicerca(filtri) {
        this.filtri = filtri
        this.filtri.tipoItem = 'PRODOTTO' // verificare come e se mettere
        await this.getDataFromApi()
      },
      async getDataFromApi() {
        try {
          this.loading = true
          this.filtri.isECommerce = true
          const data = await prodotti.getFilteredProducts(this.filtri, this.options, null, true)
          const articoli = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
          this.articoli = articoli.map(el => {
            el.allegati = el.allegati || []
            return { ...el }
          })
          this.totaleArticoli = data.total_rows
        } catch (err) {
          this.articoli = []
          this.totaleArticoli = 0
        } finally {
          this.loading = false
        }
      },
      onNuovoArticolo() {
        this.editedIndex = -1
        // this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItem)))
        this.$store.commit('prodotti/SET_PRODOTTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      editItem(item) {
        this.editedIndex = this.articoli.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('prodotti/SET_PRODOTTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      duplicateItem(item) {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        this.editedItem.barcode = []
        this.editedItem.ricercaBarcode = ''
        delete this.editedItem._rev
        this.$store.commit('prodotti/SET_PRODOTTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      deleteItemWithPassword(item) {
        if (prompt('inserire codice per cancellazione') === this.codiceCancellazione) {
          this.deleteItem(item)
        }
      },
      deleteItem(item) {
        this.editedIndex = this.articoli.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm() {
        this.articoli.splice(this.editedIndex, 1)
        // TODO: ATTENZIONE VA VERIFICATO CHE NON ABBIA STORIA
        if (!await prodotti.cancellaProdotto(this.editedItem)) {
          this.dialogErrore = true
        }
        await prodotti.clearCache()
        this.closeDelete()
      },

      close() {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async save() {
        this.$store.commit('prodotti/CLEAR_PRODOTTO_SAVED')
        this.editedItem = this.$store.getters['prodotti/prodotto']
        if (this.editedIndex > -1) {
          Object.assign(this.articoli[this.editedIndex], this.editedItem)
          if (!await prodotti.aggiornaProdotto(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        } else {
          this.articoli.push(this.editedItem)
          const newPr = await prodotti.creaProdotto(this.editedItem)
          if (!newPr) {
            this.dialogErrore = true
            return
          }
          this.$store.commit('prodotti/SET_PRODOTTO', newPr)
        }
        this.close()
        // va fatto il refresh della lista per prendere gli aggiornamenti
        await this.getDataFromApi()
      },
      erroreConfirm() {
        this.dialogErrore = false
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
        const item = options.item
        this.editedIndex = this.articoli.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('prodotti/SET_PRODOTTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      onSpeedDialogComando(comando, payload) {
        switch (comando) {
          case 'stampa-etichette':
            this.$refs.stampaEtichette.stampaEtichette(this.elencoEtichette(), 'articoli')
            this.annullaSelezione()
            break
          case 'abilita-ecommerce':
            this.dialogECommerce = true
            break
          default:
            break
        }
      },
      elencoEtichette() {
        const etichette = this.selected.map(el => {
          return {
            id: el._id,
            idpr: el._id,
            quantita: 1
          }
        })
        return etichette
      },
      async eCommerceConfirm() {
        const ids = this.selected.map(el => el._id)
        await prodotti.abilitaECommerceByIds(ids, true)
        this.dialogECommerce = false
        this.annullaSelezione()
        await this.getDataFromApi()
      },
      annullaSelezione() {
        while (this.selected.length > 0) { this.selected.pop() }
      },
      async onChangeFile({ idProdotto, tipo, payload }) {
        switch (tipo) {
          case 'addFile':
          case 'updateFile':
            await prodotti.aggiornaAllegati(idProdotto, payload)
            break
          case 'deleteFile':
            await prodotti.eliminaAllegato(idProdotto, payload)
            break
          default:
            break
        }
        await this.getDataFromApi()
        this.triggerUpdate++
      },
      async refreshAllegati(item) {
        const filtri = { id: item._id }
        const data = await prodotti.getFilteredProducts(filtri, this.options, null, true)
        const articoli = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
        item.allegati = articoli[0].allegati || []
        // this.triggerUpdate++
      },
      async salvaDescrizioni(item) {
        this.loading = true
        const descrizioni = {
          descrizione: item.eCommerce.descrizione,
          descrizioneBreve: item.eCommerce.descrizioneBreve
        }
        await eCommerce.aggiornaDescrizioniProdotto(this.item, descrizioni, this.gestioneSeparataStockVarianti)
        await delay(1000)
        await this.aggiornaConfigurazioni(item)
        this.loading = false
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content {
    box-shadow: none !important;
  }

  td.articoliSelected {
    border-style: solid !important;
    border-width: 2px !important;
    border-color: #1976d2 !important;
  }
</style>
